import React from 'react';
import PasswordContainer from 'components/BoxPasswordContainer';
import {ReactComponent as YearIcon} from 'assets/svgs/categories/year.svg';
import {generatePassword} from 'utils/common';

export default React.memo(({item, handleChange, custom}) => (
  <PasswordContainer
    type="text"
    value={item.password || ''}
    placeholder="PASSWORD"
    handleChange={(event) => handleChange('password', event.target.value)}
    icon={
      <YearIcon
        className="password-icon"
        onClick={() => {
          const password = generatePassword();
          handleChange('password', password);
        }}
      />
    }
    inputClass="form-control"
    className=""
    custom={custom}
  />
));
